import { Box } from '@material-ui/core'
import { useState, useEffect } from 'react'
import './singleinventory.css'
import AmsTypography from '../AmsTypography/AmsTypography'

const SingleInventory = (props: any) => {

    const { text, index, count, onDecrementClick, onIncrementClick,room } = props

    const handleDecrement = () => {
        onDecrementClick(index, count)
    }

    const handleIncrement = () => {
        onIncrementClick(count)
    }

    return (
        <Box className='inventoryItem' padding={"5px 0px"}>
            <Box className='textInventory' width={"30%"}>{text}</Box>
            <Box className='textInventory' textAlign={"left"} width={"40%"}>{room}</Box>
            <Box className='inventoryCount' width={"30%"}>
                <Box className='decrement' onClick={handleDecrement}>-</Box>
                <AmsTypography variant='h3' text={count} className={"count"} />
                <Box className='increment' onClick={handleIncrement}>+</Box>
            </Box>
        </Box>
    )
}

export default SingleInventory